import React, { useState, useEffect } from "react";
import { CategoryTabs } from "../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faXmark,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import { Tag } from "antd";
import { useUserContext } from "../../context";
import { subscribeUser } from "../../services/apicall";
const expandedLogo = require("../../devdata/icons/s_logo.png");

const categories = [
  { label: "Monthly", value: "Monthly" },
  { label: "Yearly", value: "Yearly" },
];

const allSubscriptionPlans = [
  {
    title: "Monthly Plan",
    description: "Full access to all features with monthly billing",
    price: "₹1,499/-",
    key: "Monthly",
  },

  {
    title: "Yearly Plan",
    description: "Full access to all features with yearly billing",
    price: "₹6,999/-",
    key: "Yearly",
  },
];

const SubscriptionModal = ({
  showPlans,
  setShowPlans,
  currentSubscription,
  loading,
  setLoading,
  setsub,
  setErrorMessage,
  setError,
}) => {
  const [order, setorder] = useState();

  const { userToken, userdetails } = useUserContext();
  const [selectedPlan, setSelectedPlan] = useState(
    currentSubscription?.type !== "none" &&
      currentSubscription?.type !== undefined
      ? currentSubscription?.type
      : "Monthly"
  );
  const [selectedPlanDetails, setSelectedPlanDetails] = useState(
    allSubscriptionPlans.find((plan) => plan.key === selectedPlan)
  );

  // Detect mobile view using window width threshold (e.g., 768px)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle plan change from category tabs (desktop view)
  const handleFilterChange = (key) => {
    // if (!currentSubscription?.type || currentSubscription?.type === "none") {
    setSelectedPlan(key);
    setSelectedPlanDetails(
      allSubscriptionPlans.find((plan) => plan.key === key)
    );
    // }
  };

  // For mobile view, handle the select dropdown change
  const handleSelectChange = (e) => {
    const key = e.target.value;
    setSelectedPlan(key);
    setSelectedPlanDetails(
      allSubscriptionPlans.find((plan) => plan.key === key)
    );
  };

  useEffect(() => {
    if (currentSubscription?.type) {
      // Optionally update categories if needed
    }
  }, [currentSubscription?.type]);
  const handleSubscribe = () => {
    subscribeUser(
      userToken,
      selectedPlan,
      setLoading,
      setorder,
      setErrorMessage,
      setError
    );
  };
  const handlePayment = async () => {
    try {
      if (!order) {
        throw new Error("Order not set");
      }
      const orderData = order;
      // Initialize Razorpay
      console.log(process.env.REACT_APP_NODE_ENV);

      const options = {
        key: orderData.razorpayKeyId,
        amount: orderData.amount,
        currency: "INR",
        name: "MarketPulse.Exchange",
        description: `${orderData.subtype} Subscription`,
        image: expandedLogo,

        order_id: orderData.id,
        handler: function (response) {
          // Handle successful payment
          window.location.href = "/profile";
        },
        prefill: {
          name: userdetails.name,
          email: userdetails.username,
          contact: userdetails.phone,
        },
        theme: {
          color: "#01e47c",
        },
      };

      const rzp1 = new window.Razorpay(options);
      rzp1.on("payment.failed", function (response) {
        setErrorMessage(
          "h_Error: Payment failed. Please try again. " +
          response.error.description
        );
        setError(true);
      });
      rzp1.open();
    } catch (error) {
      console.error("Error creating order:", error);
      setErrorMessage("h_Error: Error creating order. Please try again.");
      setError(true);
    }
  };

  useEffect(() => {
    if (order) {
      handlePayment();
    }
  }, [order]);
  return (
    <div
      className={`fixed inset-0 flex flex-col gap-10 items-center justify-center backdrop-blur-sm bg-black bg-opacity-20 z-50 ${showPlans ? "visible" : "invisible"
        }`}
    >
      <div className="bg-darkMode-background text-white p-6 rounded-3xl border-darkMode-layer3 border-2 shadow-xl relative w-3/4 max-w-3xl">
        <button
          className="absolute top-4 right-4 flex items-center justify-center p-2 text-gray-400 hover:text-gray-300 rounded-full bg-darkMode-layer2"
          onClick={() => setShowPlans(false)}
        >
          <FontAwesomeIcon
            icon={faXmark}
            size="lg"
            className="text-darkMode-subText hover:text-darkMode-red h-4 w-4"
          />
        </button>
        <h1 className="text-darkMode-text">Subscription Plans</h1>
        <div className="flex flex-col items-center mt-6 w-full max-md:max-w-full">
          {currentSubscription?.type !== "none" &&
            currentSubscription?.type !== undefined ? (
            <div className="flex gap-4 items-center py-2 px-3 text-base font-medium text-center rounded-[45px] text-darkMode-text max-md:max-w-full shadow-md relative">
              <div className="px-4 py-2 rounded-3xl min-w-[200px] relative z-10 bg-darkMode-darkGreen text-darkMode-text shadow-lg">
                {currentSubscription?.type}
              </div>
            </div>
          ) : null}
          <div className="mb-2 text-sm leading-none text-darkMode-subText flex">
            <span>Choose the plan that suits you best.</span>
          </div>
          <div className="w-full">
            {isMobile ? (
              <select
                value={selectedPlan}
                onChange={handleSelectChange}
                className="w-full p-2 rounded-md bg-darkMode-layer2 text-darkMode-text"
              >
                {categories.map((category) => (
                  <option key={category.value} value={category.value}>
                    {category.label}
                  </option>
                ))}
              </select>
            ) : (
              <CategoryTabs
                onFilterChange={handleFilterChange}
                categories={categories}
                defaultCategory={selectedPlan}
                showFilterIcon={false}
                transition={false}
              />
            )}
          </div>
          <div className="flex flex-col justify-start w-full p-4 rounded-lg shadow-md text-darkMode-text">
            <div className="flex items-center">
              <div className="px-2 py-0 mb-2 bg-darkMode-layer3 rounded-full">
                <span className="text-darkMode-subText font-bold text-xs">
                  All-in-One-Plan
                </span>
              </div>
              {selectedPlan === "Yearly" && (
                <div className="px-2 py-0 mb-2 ml-1 bg-darkMode-layer3 rounded-full ring-2 ring-darkMode-darkGreen">
                  <span className="text-darkMode-subText font-bold text-xs">
                    Most Preferred
                  </span>
                </div>
              )}
            </div>
            <p className="mb-4 text-darkMode-subText">
              {selectedPlanDetails.description}
            </p>
            <div className="flex flex-row gap-2 items-center mb-4">
              <span className="text-3xl font-bold">
                {selectedPlanDetails.price}
              </span>
              <span className="text-sm">Limited time offer</span>
            </div>
            <div className="flex flex-col text-md mb-6">
              {[
                "Access to Pi - Predictive intelligence",
                "Access to all scanners",
                'Access to "Automate Via Algotest"',
                'Access to "Updated Learning Content"',
              ].map((item) => (
                <div
                  key={item}
                  className="flex flex-row justify-start items-center gap-2 mb-1"
                >
                  <FontAwesomeIcon
                    icon={faCheck}
                    className={`h-5 w-5 text-market-teal mr-2 mt-0.5 flex-shrink-0 group-hover/item:scale-110 transition-transform duration-300`}
                  />
                  <span>{item}</span>
                </div>
              ))}
            </div>
            {!currentSubscription?.issubexp ? (
              <>
                <p className="text-sm">
                  Subscribed on:{" "}
                  <span className="font-medium">
                    {currentSubscription && currentSubscription.subon
                      ? new Date(currentSubscription.subon).toLocaleDateString(
                        "en-GB"
                      )
                      : "-"}
                  </span>
                </p>
                <p className="text-sm mb-4">
                  Expires on:{" "}
                  <span className="font-medium">
                    {currentSubscription && currentSubscription.subexp
                      ? new Date(currentSubscription.subexp).toLocaleDateString(
                        "en-GB"
                      )
                      : "-"}
                  </span>
                </p>
                <div className="flex gap-2">
                  <button
                    className="px-4 py-2 text-sm font-semibold text-darkMode-text max-w-fit bg-darkMode-darkGreen rounded-lg hover:bg-primary-hover transition"
                    onClick={() => handleSubscribe()}
                  >
                    {currentSubscription?.type === "Monthly" &&
                      selectedPlan === "Yearly"
                      ? "Upgrade"
                      : "Renew"}
                  </button>
                </div>
              </>
            ) : (
              <div className="flex items-center">
                <button
                  className="px-8 py-2 text-sm font-semibold bg-darkMode-green text-darkMode-layer1 shadow-lg rounded-xl hover:bg-primary-hover transition"
                  onClick={() => handleSubscribe()}
                  disabled={loading}
                >
                  {loading ? "Processing..." : "Subscribe"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { SubscriptionModal, allSubscriptionPlans };
export default SubscriptionModal;
